import { createGlobalStyle, css } from 'styled-components';

const SharePopupStyle = createGlobalStyle`${css`
	:root {
		--sharePopupTitleMargin: var(--sp3x) 0 var(--sp4x) 0;
		--sharePopupDescriptionMarginBottom: var(--sp9x);
		--iconWrapSizes: var(--sp14x);
		--iconSizes: var(--sp4x);
		--sharePopupLinksPaddingBottom: var(--sp10x);
		--shareLinkWrapMarginRight: var(--sp12x);
		--shareLinkMarginBottom: var(--sp3x);
		--linkMinWidth: var(--sp19x);
		--contentContainerMaxWidth: var(--sp158x);
	}

	.popup-content-container {
		max-width: var(--contentContainerMaxWidth) !important;

		.popup-content-wrap {
			min-height: fit-content !important;
			overflow: hidden !important;
		}
	}

	.share-popup-wrap {
		display: flex;
		flex-direction: column;
		align-items: center;

		.share-popup-title {
			margin: var(--sharePopupTitleMargin);
		}

		.share-popup-description {
			margin-bottom: var(--sharePopupDescriptionMarginBottom);
		}

		.share-popup-links {
			display: flex;
			flex-wrap: wrap;
			justify-content: center;
			align-items: center;
			gap: var(--shareLinkWrapMarginRight);
			padding-bottom: var(--sharePopupLinksPaddingBottom);

			.link-wrap {
				display: flex;
				flex-direction: column;
				align-items: center;
				min-width: var(--linkMinWidth);

				&:last-child {
					margin-right: 0;
				}

				.share-link {
					display: flex;
					justify-content: center;
					align-items: center;
					width: var(--iconWrapSizes);
					height: var(--iconWrapSizes);
					margin-bottom: var(--shareLinkMarginBottom);
					background-color: var(--secondaryColor4);
					border-radius: 50%;

					i {
						font-size: var(--iconSizes);
					}
				}
			}
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeL}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXLMin}) {
		:root {
			--sharePopupTitleMargin: var(--sp3x) 0 var(--sp4x) 0;
			--sharePopupDescriptionMarginBottom: var(--sp8x);
			--iconWrapSizes: var(--sp13x);
			--iconSizes: var(--sp4x);
			--sharePopupLinksPaddingBottom: var(--sp9x);
			--shareLinkWrapMarginRight: var(--sp10x);
			--shareLinkMarginBottom: var(--sp2x);
			--linkMinWidth: var(--sp14x);
			--contentContainerMaxWidth: var(--sp123x);
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeM}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeLMin}) {
		:root {
			--sharePopupTitleMargin: var(--sp3x) 0;
			--sharePopupDescriptionMarginBottom: var(--sp6x);
			--iconWrapSizes: var(--sp12x);
			--iconSizes: var(--sp4x);
			--sharePopupLinksPaddingBottom: var(--sp8x);
			--shareLinkWrapMarginRight: var(--sp8x);
			--shareLinkMarginBottom: var(--sp2x);
			--linkMinWidth: var(--sp12x);
			--contentContainerMaxWidth: var(--sp94x);
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeMMin}) {
		:root {
			--sharePopupTitleMargin: var(--sp3x) 0;
			--sharePopupDescriptionMarginBottom: var(--sp6x);
			--iconWrapSizes: var(--sp11x);
			--iconSizes: var(--sp3x);
			--sharePopupLinksPaddingBottom: var(--sp8x);
			--shareLinkWrapMarginRight: var(--sp7x);
			--shareLinkMarginBottom: var(--sp2x);
			--linkMinWidth: var(--sp12x);
			--contentContainerMaxWidth: var(--sp89x);
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXS}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeSMin}) {
		:root {
			--sharePopupTitleMargin: var(--sp3x) 0;
			--sharePopupDescriptionMarginBottom: var(--sp6x);
			--iconWrapSizes: var(--sp11x);
			--iconSizes: var(--sp3x);
			--sharePopupLinksPaddingBottom: var(--sp8x);
			--shareLinkWrapMarginRight: var(--sp7x);
			--shareLinkMarginBottom: var(--sp2x);
			--linkMinWidth: var(--sp12x);
			--contentContainerMaxWidth: var(--sp89x);
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSize}) and (max-width: ${({ theme }) => theme.mediaQuery.DesktopSizeXSMin}) {
		:root {
			--sharePopupTitleMargin: 0 0 var(--sp2x) 0;
			--sharePopupDescriptionMarginBottom: var(--sp4x);
			--iconWrapSizes: var(--sp9x);
			--iconSizes: var(--sp3x);
			--sharePopupLinksPaddingBottom: var(--sp5x);
			--shareLinkWrapMarginRight: var(--sp6x);
			--shareLinkMarginBottom: var(--sp2x);
			--linkMinWidth: var(--sp12x);
			--contentContainerMaxWidth: var(--sp72x);
		}
	}

	@media (min-width: ${({ theme }) => theme.mediaQuery.TabletSizeS}) and (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeMin}) {
		:root {
			--sharePopupTitleMargin: 0 0 var(--sp2x) 0;
			--sharePopupDescriptionMarginBottom: var(--sp4x);
			--iconWrapSizes: var(--sp9x);
			--iconSizes: var(--sp3x);
			--sharePopupLinksPaddingBottom: var(--sp5x);
			--shareLinkWrapMarginRight: var(--sp6x);
			--shareLinkMarginBottom: var(--sp2x);
			--linkMinWidth: var(--sp11x);
			--contentContainerMaxWidth: var(--sp60x);
		}
	}

	@media (max-width: ${({ theme }) => theme.mediaQuery.TabletSizeSMin}) {
		:root {
			--sharePopupTitleMargin: 0 0 var(--sp2x) 0;
			--sharePopupDescriptionMarginBottom: var(--sp4x);
			--iconWrapSizes: var(--sp9x);
			--iconSizes: var(--sp3x);
			--sharePopupLinksPaddingBottom: var(--sp5x);
			--shareLinkWrapMarginRight: var(--sp6x);
			--shareLinkMarginBottom: var(--sp2x);
			--linkMinWidth: var(--sp11x);
			--contentContainerMaxWidth: calc(100% - 32px);
		}
	}
`}`;

export default SharePopupStyle;
